<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '400px' }"
  [header]="'Go to coordinates' | translate"
  (onHide)="close()"
>
  <div class="form-section">
    <msf-form-builder
      [fields]="fields"
      [(model)]="formModel"
      flexDirection="column"
    ></msf-form-builder>
    <div class="actions mt-3 flex flex-row-reverse gap-2">
      <app-primary-button
        [title]="'Go to' | translate"
        [disable]="formModel.lat === null || formModel.lng === null"
        (action)="goToCoordinates()"
      ></app-primary-button>

      <app-secondary-button
        [title]="'Cancel' | translate"
        (action)="close()"
      ></app-secondary-button>
    </div>
  </div>
</p-dialog>
